module.exports = __webpack_public_path__ + "img/hcml_main1.8c7f9dcf.jpg";